"use strict";

var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
      m = s && o[s],
      i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProfiles = exports.Profile = exports.decodeProfile = exports.ReadingEntry = void 0;

var port_index_1 = require("./port_index");

var profile_1 = require("./http/profile");

var ReadingEntry =
/** @class */
function () {
  function ReadingEntry(number, entry, minPeriod, maxPeriod, readingMethod, shoudDownload) {
    this.number = number;
    this.entry = entry;
    this.minPeriod = minPeriod;
    this.maxPeriod = maxPeriod;
    this.readingMethod = readingMethod;
    this.shouldDownload = shoudDownload;
  }

  ReadingEntry.prototype.equal = function (e) {
    return this.entry.equal(e.entry) && this.maxPeriod === e.maxPeriod && this.minPeriod === e.minPeriod && this.readingMethod === e.readingMethod;
  };

  return ReadingEntry;
}();

exports.ReadingEntry = ReadingEntry;
;
/* { "object": "123", "resource": "123", "instance": "123", "extra_selector": "1",
     "minperiod": 900, "maxperiod": 1200, "should_download": false, "reading_method": "string" } */

function decodeReadingEntry(e) {
  var entry = new port_index_1.PortIndex("");
  entry.object = e.object;
  entry.resource = e.resource;
  entry.objectInstance = e.instance;
  entry.instance = e.extra_selector;
  return new ReadingEntry(-1, entry, e.minperiod, e.maxperiod, e.reading_method, e.should_download);
}

function encodeReadingEntry() {}

;
;

function decodeProfile(p) {
  var e_1, _a;

  var schedulingProfile = undefined;

  if (p.scheduling_profile != null) {
    schedulingProfile = JSON.parse(p.scheduling_profile);
  }

  var profile = new Profile(p.id, p.name, p.labels, p.version, p.scheduling_method, schedulingProfile);

  try {
    for (var _b = __values(p.reading_entries), _c = _b.next(); !_c.done; _c = _b.next()) {
      var entry = _c.value;
      profile.addReadingEntry(decodeReadingEntry(entry));
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  profile.readingEntries.sort(function (a, b) {
    return a.minPeriod - b.minPeriod;
  });
  return profile;
}

exports.decodeProfile = decodeProfile;

var Profile =
/** @class */
function () {
  // scheduling_profile
  function Profile(id, name, labels, version, schedulingMethod, schedulingProfile, readingEntries, alerting) {
    if (readingEntries === void 0) {
      readingEntries = [];
    }

    if (alerting === void 0) {
      alerting = [];
    }

    this.id = id;
    this.name = name;
    this.labels = labels;
    this.version = version;
    this.schedulingMethod = schedulingMethod;
    this.schedulingProfile = schedulingProfile;
    this.readingEntries = readingEntries;
    this.alerting = alerting;
  }

  ;

  Profile.prototype.equal = function (entry1, entry2) {
    return entry1.equal(entry2);
  };

  Profile.prototype.addReadingEntry = function (entry) {
    entry.number = this.readingEntries.length;
    this.readingEntries.push(entry);
  };

  Profile.prototype.findEntry = function (entry) {
    var e_2, _a;

    try {
      for (var _b = __values(this.readingEntries), _c = _b.next(); !_c.done; _c = _b.next()) {
        var e = _c.value;

        if (entry.entry.equal(e.entry)) {
          return e;
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }

    return undefined;
  };

  ;

  Profile.prototype.removeEntry = function (entry) {
    for (var i = 0; i < this.readingEntries.length; i++) {
      if (entry.entry.equal(this.readingEntries[i].entry)) {
        this.readingEntries.splice(i, 1);
        return true;
      }
    }

    return false;
  };

  return Profile;
}();

exports.Profile = Profile;
;

function getProfiles(cred) {
  return profile_1.get(cred).then(function (resp) {
    var e_3, _a;

    var profiles = [];

    try {
      for (var resp_1 = __values(resp), resp_1_1 = resp_1.next(); !resp_1_1.done; resp_1_1 = resp_1.next()) {
        var rawProfile = resp_1_1.value;
        profiles.push(decodeProfile(rawProfile));
      }
    } catch (e_3_1) {
      e_3 = {
        error: e_3_1
      };
    } finally {
      try {
        if (resp_1_1 && !resp_1_1.done && (_a = resp_1.return)) _a.call(resp_1);
      } finally {
        if (e_3) throw e_3.error;
      }
    }

    return profiles;
  });
}

exports.getProfiles = getProfiles;